import { gql } from "@apollo/client";import { useQuery } from "@apollo/client/react";import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import MainContent from '../../components/mainContent/MainContent';

import ConfigPreset from './components/ConfigPreset';
import ErrorDialog from '../../components/ErrorDialog';

export default function Preferencias() {

  const navigate = useNavigate();

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  // dlg de error
  //const [opendDlgError, setOpenDlgError] = useState(false);
  //const [mensajeError, setMensajeError] = useState("");       

  // useEffect(() => {
  //     setOpenDlgError(mensajeError!=="");
  // }, [mensajeError]);   

  // const handleCloseDlgError = () => {
  //     navigate("/menu");
  // };     


  const QTipoPresetUsuario = gql`
        query QTipoPresetUsuario{
            tipoPreset {
                success,
                error,
                valorEsperado {
                  id,
                  descripcion,
                  activo
                }
              }
        }`;

  const { loading, error, data, setError } = useQuery(QTipoPresetUsuario, { fetchPolicy: 'no-cache' });

  if (loading) return <MainContent component={<CircularProgress disableShrink />} titulo='Configuración de Preset' />;

  if (error) {
    return (
      <>
              <MainContent titulo='Configuración de Preset' />        
    
              {/* <ErrorDialog
             id="dlg-error-presetUsuario"
             open={error != null}
             onClose={handleCloseDlgError}
             mensaje="ERRORDB"
          /> */}
    
            </>);

  }

  if (data) {
    return (
      <MainContent component={<ConfigPreset data={data} />} titulo='Configuración de Preset' />);

  }

};